import React from 'react';
import Typography from '@material-ui/core/Typography';

const shouldShowWarning = (syncStatus) => syncStatus && syncStatus.status && syncStatus.status !== 'ok';

const isIssueStatus = (syncStatus) => syncStatus && ['blocked', 'conflicted', 'error'].includes(syncStatus.status);

const TaskDashboardSyncWarning = ({ syncStatus }) => {
   if (!shouldShowWarning(syncStatus)) {
      return null;
   }

   const isIssue = isIssueStatus(syncStatus);
   const title = isIssue ? 'Offline sync issue' : 'Offline updates pending';
   const message = isIssue
      ? 'Some uploaded work has not finished processing. This report may be out of date.'
      : syncStatus.message || 'Some recent offline work may not yet be reflected in this report.';

   return (
      <div
         style={{
            margin: '12px 16px',
            padding: '12px 14px',
            borderRadius: 8,
            border: `1px solid ${isIssue ? '#d32f2f' : '#FFB74D'}`,
            backgroundColor: isIssue ? '#FDECEA' : '#FFF4E5'
         }}>
         <Typography style={{ fontWeight: 700, marginBottom: 4 }}>{title}</Typography>
         <Typography variant='body2'>{message}</Typography>
      </div>
   );
};

export default TaskDashboardSyncWarning;
